import { useState } from "react";
import type { ReportingActivity } from "../../types/reporting";
import type { ComparisonMonths, TrendMonths } from "./insight-period";

const KEY = "barnyard:insights-trend";

function readPreference(name: string) {
  try { return localStorage.getItem(`barnyard:insights-${name}`); } catch { return null; }
}
function savePreference(name: string, value: string) {
  try { localStorage.setItem(`barnyard:insights-${name}`, value); } catch { /* Storage is optional. */ }
}

export function useInsightPreferences() {
  const [months, setValue] = useState<TrendMonths>(() => {
    try {
      const saved = Number(localStorage.getItem(KEY));
      if (saved === 3 || saved === 6 || saved === 12) return saved;
    } catch { /* The preference can still last for this visit. */ }
    return 6;
  });
  function setMonths(value: TrendMonths) {
    setValue(value);
    try { localStorage.setItem(KEY, String(value)); } catch { /* Storage is optional. */ }
  }
  const [comparison, setComparison] = useState<ComparisonMonths>(() => readPreference("comparison") === "3" ? 3 : 1);
  const [activity, setActivity] = useState<ReportingActivity>(() => { const value = readPreference("activity"); return value === "trips" || value === "everyday" ? value : "all"; });
  return { months, setMonths, comparison, activity,
    setComparison: (value: ComparisonMonths) => { setComparison(value); savePreference("comparison", String(value)); },
    setActivity: (value: ReportingActivity) => { setActivity(value); savePreference("activity", value); },
  };
}
